import React from 'react'
import styles from './styles.module.scss'
import Link from 'next/link'

export default function TermsOfUse() {
    return (
        <div className={`font-sm ${styles.termsArea}`}>
            <span>Ao continuar, você concorda com os nossos</span>
            <label>
                <u><Link href={'https://menudino.com/termos-de-uso'} target='_blank'>Termos de uso</Link></u> e <u><Link href={'https://consumer.com.br/politica-de-privacidade'} target='_blank'>políticas de privacidade</Link></u>
            </label>
        </div>
    )
}
